// src/components/Auth/Register.js
import React, { useState, useEffect } from 'react';
import { Form, Button, Alert, Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AuthService from '../../services/auth.service';
import GeografiaService from '../../services/geografia.service';

const Register = () => {
  const [nombre, setNombre] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [departamentoId, setDepartamentoId] = useState('');
  const [municipioId, setMunicipioId] = useState('');
  const [departamentos, setDepartamentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [successful, setSuccessful] = useState(false);

  // Cargar departamentos al montar el componente
  useEffect(() => {
    GeografiaService.getDepartamentos()
      .then(response => {
        setDepartamentos(response.data);
      })
      .catch(error => {
        console.error("Error al cargar departamentos:", error);
      });
  }, []);

  // Cargar municipios cuando cambia el departamento
  useEffect(() => {
    if (departamentoId) {
      GeografiaService.getMunicipiosByDepartamento(departamentoId)
        .then(response => {
          setMunicipios(response.data);
          setMunicipioId(''); // Resetear municipio cuando cambia el departamento
        })
        .catch(error => {
          console.error("Error al cargar municipios:", error);
        });
    } else {
      setMunicipios([]);
      setMunicipioId('');
    }
  }, [departamentoId]);

  const handleRegister = (e) => {
    e.preventDefault();
    setMessage('');
    setLoading(true);
    setSuccessful(false);

    if (password !== confirmPassword) {
      setMessage('Las contraseñas no coinciden');
      setLoading(false);
      return;
    }

    if (!municipioId) {
      setMessage('Por favor seleccione un municipio');
      setLoading(false);
      return;
    }

    AuthService.register(nombre, email, password, parseInt(municipioId))
      .then(response => {
        setMessage('Registro exitoso. Por favor revisa tu correo para confirmar tu cuenta.');
        setSuccessful(true);
        setLoading(false);
      })
      .catch(error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.detail) ||
          error.message ||
          error.toString();
        setMessage(resMessage);
        setSuccessful(false);
        setLoading(false);
      });
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={6}>
          <Card>
            <Card.Header as="h5" className="text-center">Registro de Usuario</Card.Header>
            <Card.Body>
              {successful ? (
                <Alert variant="success">{message}</Alert>
              ) : (
                <Form onSubmit={handleRegister}>
                  <Form.Group className="mb-3">
                    <Form.Label>Nombre Completo</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ingrese su nombre"
                      value={nombre}
                      onChange={(e) => setNombre(e.target.value)}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Correo Electrónico</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Ingrese su correo"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Departamento</Form.Label>
                    <Form.Select
                      value={departamentoId}
                      onChange={(e) => setDepartamentoId(e.target.value)}
                      required
                    >
                      <option value="">Seleccione un departamento</option>
                      {departamentos.map(dept => (
                        <option key={dept.id} value={dept.id}>{dept.nombre}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Municipio</Form.Label>
                    <Form.Select
                      value={municipioId}
                      onChange={(e) => setMunicipioId(e.target.value)}
                      disabled={!departamentoId}
                      required
                    >
                      <option value="">Seleccione un municipio</option>
                      {municipios.map(mun => (
                        <option key={mun.id} value={mun.id}>{mun.nombre}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Contraseña</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Ingrese su contraseña"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      minLength="8"
                    />
                    <Form.Text className="text-muted">
                      La contraseña debe tener al menos 8 caracteres.
                    </Form.Text>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Confirmar Contraseña</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Confirme su contraseña"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                      minLength="8"
                    />
                  </Form.Group>

                  <Button variant="primary" type="submit" disabled={loading} className="w-100 mt-3">
                    {loading ? 'Cargando...' : 'Registrarse'}
                  </Button>

                  {message && (
                    <Alert variant="danger" className="mt-3">
                      {message}
                    </Alert>
                  )}
                </Form>
              )}
            </Card.Body>
            <Card.Footer className="text-center">
              ¿Ya tienes cuenta? <Link to="/login">Inicia sesión</Link>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Register;